import * as React from 'react';
import classnames from 'classnames';

import { __t, applyTranslations } from 'utils/language';
import { getDateDiffInYears } from 'utils/date';

import './underage-legal-warning.scss';

applyTranslations(require('./underage-legal-warning.i18n.json'));

type Props = {
  dateOfBirth: string | undefined | null,
  className?: string
};

const UnderageLegalWarning: React.FunctionComponent<Props> = ({
  dateOfBirth,
  className
}: Props) => {
  const age = getDateDiffInYears(Date.now(), dateOfBirth);
  if (!dateOfBirth || age >= 18) {
    return null;
  }

  const containerClasses = classnames('underage-legal-warning', className);

  return (
    <div className={containerClasses}>
      <div className="underage-legal-warning__section">
        {__t('underage_legal_warning.warning_a')}
      </div>
      <div className="underage-legal-warning__section">
        {__t('underage_legal_warning.warning_b')}
      </div>
    </div>
  );
};

export default UnderageLegalWarning;
